import {
    GETCHARGEBACKLIST_SUCCESS,
    GETCHARGEBACKLIST_FAILED,
    RESET_GETCHARGEBACKLIST,
    LOADING_GETCHARGEBACKLIST,
    NETWORK_ERROR_GETCHARGEBACKLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETCHARGEBACKLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETCHARGEBACKLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETCHARGEBACKLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETCHARGEBACKLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETCHARGEBACKLIST:
            return (state = initialState);
        default:
            return state;
    }
};